import script from "./QuestionGenDraftReviewTable.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionGenDraftReviewTable.vue?vue&type=script&setup=true&lang=js"

import "./QuestionGenDraftReviewTable.vue?vue&type=style&index=0&id=e32176ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e32176ac"]])

export default __exports__